import React from 'react';

import CountrySelect from './components/CountrySelect/CountrySelect';
import PageHeader from '../PageHeader';

const CountryListPage = () => {
	return (
		<div className='Devices'>
			<PageHeader header='Phone-code' collapsed={true} />

			<CountrySelect />
		</div>
	);
};

export default CountryListPage;
